import _typeof from "@babel/runtime-corejs3/helpers/esm/typeof";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Map from "@babel/runtime-corejs3/core-js-stable/map";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/* eslint class-methods-use-this: ["error", { "exceptMethods":
["validJsonInput", "getValueDateOrNull"] }] */

/* eslint-disable prettier/prettier */

import CodeTable from '../Codetable/CodetableService';
/**
 * The Profile data model.
 *
 * @export
 * @class ProfileModel
 */

var ProfileModel = /*#__PURE__*/function () {
  /**
   * Creates an instance of ProfileModel.
   * @param {any} json input json
   * @memberof ProfileModel
   */
  function ProfileModel(json) {
    var _context,
        _this = this,
        _context2,
        _context3,
        _context4;

    _classCallCheck(this, ProfileModel); // Check the json object and return an empty {@link ProfileModel}
    // object when contact details are restricted or input invalid.


    if (!this.validJsonInput(json)) {
      return;
    }
    /** The uniqueID of this user  */


    this.personId = json.person_id;
    /** A {@link Date} object representing the users DOB */

    this.dateOfBirth = this.getValueDateOrNull(json.dateOfBirth);
    /** The fullname of the user */

    this.fullName = json.fullName;
    /** The URL of the profile photo */

    this.photo = json.photo;
    this.registeredPersonDetails = new _Map();
    /** A list of Address objects */

    this.registeredPersonDetails.addresses = _mapInstanceProperty(_context = json.registeredPersonDetails.addresses).call(_context, function (addressJson) {
      _this.address = {};
      _this.address.addressId = addressJson.address_id;
      _this.address.address = addressJson.address;
      _this.address.type = CodeTable.fromJSON(addressJson.type);
      _this.address.addressDetails = new _Map();
      _this.address.addressDetails.addressLayoutType = addressJson.addressDetails.addressLayoutType;
      _this.address.addressDetails.address = addressJson.addressDetails.addressJSON;
      return _this.address;
    });
    /** A list of EmailAddress objects */

    this.registeredPersonDetails.emailAddresses = _mapInstanceProperty(_context2 = json.registeredPersonDetails.emailAddresses).call(_context2, function (emailAddressJson) {
      _this.emailAddress = {};
      _this.emailAddress.emailAddressId = emailAddressJson.email_address_id;
      _this.emailAddress.email = emailAddressJson.email;
      _this.emailAddress.type = CodeTable.fromJSON(emailAddressJson.type);
      return _this.emailAddress;
    });
    /** A list of Identifications objects */

    this.registeredPersonDetails.identifications = _mapInstanceProperty(_context3 = json.registeredPersonDetails.identifications).call(_context3, function (identificationJson) {
      _this.identification = {};
      _this.identification.identificationNumber = identificationJson.identificationNumber;
      _this.identification.identificationType = CodeTable.fromJSON(identificationJson.identificationType);
      return _this.identification;
    });
    /** A list of PhoneNumber objects */

    this.registeredPersonDetails.phoneNumbers = _mapInstanceProperty(_context4 = json.registeredPersonDetails.phoneNumbers).call(_context4, function (phoneNumberJson) {
      var _context5, _context6, _context7, _context8;

      _this.phoneNumber = {};
      _this.phoneNumber.phoneNumberId = phoneNumberJson.phone_number_id;
      _this.phoneNumber.areaCode = phoneNumberJson.areaCode;
      _this.phoneNumber.countryCode = phoneNumberJson.countryCode;
      _this.phoneNumber.extension = phoneNumberJson.extension;
      _this.phoneNumber.number = phoneNumberJson.number;
      _this.phoneNumber.type = CodeTable.fromJSON(phoneNumberJson.type);
      _this.phoneNumber.fullPhoneNumber = _concatInstanceProperty(_context5 = _concatInstanceProperty(_context6 = _concatInstanceProperty(_context7 = _concatInstanceProperty(_context8 = "").call(_context8, phoneNumberJson.countryCode)).call(_context7, phoneNumberJson.areaCode)).call(_context6, phoneNumberJson.number)).call(_context5, phoneNumberJson.extension);
      return _this.phoneNumber;
    });
  }
  /**
   * Check the input json object, if it is null or does not contain
   * at least the username then the contact details have been restricted or there
   * was an error.
   *
   * ESLint exception added to top of file to ignore this function.
   * Reason: currently an eslint rule requires private functions of a class to
   * store function parameters in the object itself using the this keyword before modifying.
   * E.g. this.storedJsonObject = jsonObject;
   *
   * Doing this will wrap this class in a storedJsonObject variable when serializing
   * to JSON. So the decision was made to add the eslint exception instead of
   * causing this classes data to be wrapped during serialization.
   *
   * @param {Object} jsonObject response from the server.
   * @private
   */


  _createClass(ProfileModel, [{
    key: "validJsonInput",
    value: function validJsonInput(jsonObject) {
      return jsonObject !== null && 'fullName' in jsonObject && _typeof(jsonObject.fullName) !== 'object';
    }
    /**
     * Check if the date is valid, if true return new Date object, else return null.
     * Reason: Passing a null value to the Date constructor results in a date of 1970-01-01.
     *
     * @param {string} date string.
     * @private
     */

  }, {
    key: "getValueDateOrNull",
    value: function getValueDateOrNull(date) {
      if (date) {
        return new Date(date);
      }

      return null;
    }
  }]);

  return ProfileModel;
}();

export { ProfileModel as default };